/*
 * ------
 * Initialise Vue (currently only used in the module manager)
 *
 */
/* global Framework */

import Vue from 'vue';
import ModuleTree from './components/ModuleTree';
import CKEditor from 'ckeditor4-vue/dist/legacy.js';
import Wysiwyg from './components/WysiwygEditor';
import ShowIfInput from './components/ShowIfInput';
import ShowCondition from './components/ShowCondition';
import ShowConditionField from './components/ShowConditionField';
import ShowConditionGroup from './components/ShowConditionGroup';
import RepeatingInputs from './components/RepeatingInputsTable';
import QuestionNote from './components/QuestionNote';
import QuestionHistory from './components/QuestionHistory';
import FileQuestionInput from './components/FileQuestionInput';
import Multiselect from 'vue-multiselect';
import Fragment from 'vue-fragment';
import * as Sentry from '@sentry/browser';

window.Vue = Vue;

// Create an event bus to communicate between Vue components
window.Event = new Vue();

Vue.use(CKEditor);
Vue.use(Fragment.Plugin);

// Set component names
Vue.component('module-tree', ModuleTree);
Vue.component('wysiwyg', Wysiwyg);
Vue.component('show-if-input', ShowIfInput);
Vue.component('show-condition', ShowCondition);
Vue.component('show-condition-field', ShowConditionField);
Vue.component('show-condition-group', ShowConditionGroup);
Vue.component('multiselect', Multiselect);
Vue.component('repeating-inputs', RepeatingInputs);
Vue.component('question-note', QuestionNote);
Vue.component('question-history', QuestionHistory);
Vue.component('file-question-input', FileQuestionInput);

new Vue({
  el: '#formengine-app',
});

/*
 * Framework
 *
 * Init
 * ------
 * Initialise all functionality
 *
 * Init can be immediate, on DOM load, or on window load
 */

(function ($) {
  'use strict';

  // inits
  immediateInit();
  $(document).ready(domInit);
  $(window).on('load', pageInit);

  /*
   * Run immediately
   */
  function immediateInit() {
    // Set up Sentry for reporting JS errors
    const sentryDsn = process.env.MIX_SENTRY_DSN;
    const sentryEnv = process.env.MIX_APP_ENV;
    Sentry.init({
      dsn: sentryDsn,
      environment: sentryEnv,
    });
    // Set up global window width listener
    // (for global responsive media query testing)
    Framework.windowWidth = new Framework.WindowWidth();
    Framework.windowWidth.init();
  }

  /*
   * Run on DOM load
   */
  function domInit() {
    // Miscellaneous short jquery snippets
    var snippets = new Framework.Snippets();
    snippets.init();

    // Initialise and add listeners for main greedy nav
    var mainNav = new Framework.MainNav();
    mainNav.init();

    // Initialise and add listeners for conditional questions
    var conditionalQuestions = new Framework.ConditionalQuestions();
    conditionalQuestions.init();

    // Initialise list search expand
    var listSearchExpand = new Framework.ListSearchExpand();
    listSearchExpand.init();

    // Initialise and add listeners for navigation warning
    var formValidation = new Framework.FormValidation();
    formValidation.init();

    // Initialise and add listeners for navigation warning
    var navigationWarning = new Framework.NavigationWarning();
    navigationWarning.init();

    // Initialise and add listeners for confirmation dialog
    var confirmationDialog = new Framework.ConfirmationDialog();
    confirmationDialog.init();

    // Initialise and add listeners for conditional questions
    var deletionConfirmation = new Framework.DeletionConfirmation();
    deletionConfirmation.init();

    // Initialise and add listeners for calculation of page totals
    var pageTotals = new Framework.PageTotals(); // eslint-disable-line

    // Initialise and add listeners for repeater questions
    this.$repeatingQuestionElements =
      $('[data-question-type="Repeater"]') || $('[data-question-type="File"]');
    this.$repeatingQuestionElements.each(
      (i, elem) => new Framework.RepeatingQuestion(elem)
    );

    // Initialise and add listeners for file upload questions
    this.$fileUploadQuestionElements = $('[data-question-type="File"]');
    this.$fileUploadQuestionElements.each(
      (i, elem) => new Framework.RepeatingQuestion(elem)
    );

    var $inputs = $(':radio, :checkbox');
    var selectionButtons = new Framework.SelectionButtons($inputs); // eslint-disable-line

    var fitText = new Framework.FitText(); // eslint-disable-line
    Framework.fileUploadQuestionObjs = [];
    // Initialise table sorting
    $('.js-sort-table').tablesorter();

    // Enhance selects with lots of options to include autocomplete
    // Get old select value if it exists (used for dynamic selects)
    $('.js-select2').each(function () {
      if ($(this).data('old-selection')) {
        const oldVal = $(this).data('old-selection');
        $(this).val(oldVal).select2();
      } else {
        $(this).select2();
      }
    });

    // Select2 with Other option always returned when the user is searching
    $('.js-select2-other').select2({
      matcher: function (params, data) {
        if (data.element.classList.contains('js-select2-other-always-show')) {
          return data;
        }
        return $.fn.select2.defaults.defaults.matcher(params, data);
      },
    });
  }

  /*
   * Run on page (window) load
   */
  function pageInit() {}
})(window.jQuery);
